<template>
    <div class="flex-row">
      <slot></slot>
    </div>
</template>

<script>
export default {
  name: 'FlexRow'
};
</script>
